exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.video-js .vjs-volume-tooltip{word-break:keep-all\n}\n.video-js .vjs-big-play-button{top:50%;left:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)\n}\n.video-js .vjs-big-play-button .vjs-icon-placeholder:before{top:5px !important\n}\n.video-js .vjs-time-tooltip{width:80px !important;padding:6px 8px !important\n}\n.vjs-error .vjs-error-display:before{content:\"\"\n}\n.vjs-error .vjs-error-display .vjs-modal-dialog-content{display:none\n}", ""]);

// exports
